'use client';

import dynamic from 'next/dynamic';

const BodyBackgroundInit = dynamic(() => import('./BodyBackgroundInit'), {
  ssr: false,
});

export default function BodyBackgroundInitClient() {
  return <BodyBackgroundInit />;
}
